import React from "react";

function GroupCard(props) {
  return props.children.length == 1 ? (
    <div className="my-auto">{props.children}</div>
  ) : (
    <>
      <div className="flex border-2 sm:flex-row flex-col bg-blue-100 border-dashed border-primary m-2 rounded-md">
        {props.children}
      </div>
    </>
  );
}

export default GroupCard;
